import * as React from 'react';
import {TextareaHTMLAttributes} from 'react';

import {Label} from '../Label';

import {TextareaContainer, TextareaElem} from './styled';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    hasError?: boolean;
    label?: string;
    isRequired?: boolean;
    formFieldName?: string;
    updatedStyle?: boolean;
}

export function Textarea(props: Props) {
    const {
        className,
        label,
        disabled = false,
        hasError,
        isRequired = false,
        updatedStyle = false,
        ...otherProps
    } = props;

    return (
        <TextareaContainer className={className}>
            <Label
                text={label}
                hasError={hasError}
                isRequired={isRequired}
                updatedStyle={updatedStyle}
            >
                <TextareaElem
                    hasError={hasError}
                    disabled={disabled}
                    updatedStyle={updatedStyle}
                    {...otherProps}
                />
            </Label>
        </TextareaContainer>
    );
}
